import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-lease-agreement-count',
    templateUrl: './lease-agreement-count.component.html',
    styleUrls: ['./lease-agreement-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeaseAgreementCountComponent implements OnInit {
  constructor() {}

  @Input() number: number;

  ngOnInit() {}
}
